import * as React from 'react';
import { T, TPlainTextKey } from '../../../Translations';
import { EffectiveTier } from './Types';

interface Props {
  tier: EffectiveTier;
  disabled: boolean;
}

const tierLabel = (tier: EffectiveTier): TPlainTextKey => {
  switch (tier) {
    case 'collection':
      return 'This collection';
    case 'organization':
      return 'Organization';
    case 'default':
      return 'Default';
  }
};

const tierClassName = (tier: EffectiveTier): string => {
  switch (tier) {
    case 'collection':
      return 'bg-primary text-primary-foreground';
    case 'organization':
      // --secondary is near-white, so the pill needs a border to read as one
      return 'bg-secondary text-secondary-foreground border border-primary';
    case 'default':
      return 'bg-muted text-muted-foreground border border-transparent';
  }
};

// "Off" replaces the tier rather than sitting beside it: while a
// communication is disabled, which tier would have supplied the copy is not
// the thing the admin needs to see.
const TierBadge: React.FC<Props> = ({ tier, disabled }) =>
  disabled ? (
    <span
      className="inline-flex items-center px-2 py-0.5 rounded-full whitespace-nowrap bg-muted-foreground text-background"
      style={{ fontSize: '11px', fontWeight: 'var(--font-weight-medium)' }}
    >
      <T kind="Off" />
    </span>
  ) : (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full whitespace-nowrap ${tierClassName(
        tier,
      )}`}
      style={{ fontSize: '11px', fontWeight: 'var(--font-weight-medium)' }}
    >
      <T kind={tierLabel(tier)} />
    </span>
  );

export default TierBadge;
